import DgSearch from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgSearch.install = function (Vue) {
  Vue.component(DgSearch.name, DgSearch)
}
export default DgSearch

export { DgSearch }
